import { PrimitiveAtom, atom, useAtom, useSetAtom } from "jotai";
import { CartValidatorResponse } from "../utils/interfaces";

const validatorAtom = atom<CartValidatorResponse | undefined>(
  undefined
) as PrimitiveAtom<CartValidatorResponse | undefined>;

const useValidator = () => {
  const atom = useAtom(validatorAtom);
  return atom;
};

export const useSetValidator = () => useSetAtom(validatorAtom);

export default useValidator;
